import React from 'react';
import { connect } from 'react-redux';
import { fetchProjects, resetProjects, deleteProject } from '../../../actions';
import { Row, Modal, Button } from 'react-bootstrap';
import ProjectsTable from './ProjectsTable';
import ProjectPlaceholder from './ProjectPlaceholder';
import { Trans, withTranslation } from 'react-i18next';

class ProjectsCloudList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            deletingLoader: false,
            projectToDelete: null,
        };

        this.deleteProject = this.deleteProject.bind(this);
    }

    componentDidMount() {
        this.props.fetchProjects();
    }

    deleteProject() {
        //starting loader
        this.setState({ deletingLoader: true });

        this.props.deleteProject(this.state.projectToDelete.id)
            .then(() => {
                this.props.fetchProjects()
                    .then(() => {
                        //stop loader
                        this.setState({ projectToDelete: null, deletingLoader: false });
                    });
            });
    }

    componentWillUnmount() {
        this.props.resetProjects();
    }

    render() {

        if (!this.props.projects || this.state.deletingLoader) {
            return (<ProjectPlaceholder />);
        }

        return (
            <div className="container-project-cloud-list">
                <Row className="header-project-cloud-list" style={{ height: "5vh" }}>
                    <b><Trans i18nKey="Projects" /></b>
                </Row>

                <ProjectsTable
                    projects={this.props.projects}
                    onAskDelete={(project) => this.setState({ projectToDelete: project })}
                    t={this.props.t} />

                <Modal show={this.state.projectToDelete !== null} onHide={() => this.setState({ projectToDelete: null })} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#E95B0D" }}><Trans i18nKey="Warning" /></Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p> <Trans i18nKey="Delete_Project_Confirmation" /> <i>{this.state.projectToDelete ? this.state.projectToDelete.name : this.props.t('the_project')}</i> ? </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" style={{ marginRight: "0" }} onClick={this.deleteProject}><Trans i18nKey="Yes" /></Button>
                        <Button variant="secondary" onClick={() => this.setState({ projectToDelete: null })}><Trans i18nKey="No" /></Button>
                    </Modal.Footer>
                </Modal>
                {/* <div className="overflow-y ui celled list segment">{this.renderList()}</div> */}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        projects: state.projects != null ? Object.values(state.projects) : null,
    };
};

const mapDispatchToProps = {
    fetchProjects,
    resetProjects,
    deleteProject
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(ProjectsCloudList));
